/* eslint-disable no-console */
import localStore from '../../api/localStore'
import { i18n } from '../../i18n'
import { unregisterDevice } from '../../push-notification'
import { auth } from '@/plugins/auth'
import { clearCachedValues, getOrSetCachedValue } from '../../api/localItemsCache'
import { secondFactorLogin, getUserInfo } from '../../api/auth/api.js'
import settings from '../../../public/settings.json'

const serviceName = 'EAM.QR.GETUSERINFO'

const state = {
  user: null,
  loginDialog: false,
  signInChecked: false,
  waitingSecondFactorAuth: false
}

const getters = {
  isAuthenticated(state) {
    return state.user !== null && state.user !== undefined
  },
  user: state => state.user,
}

const actions = {
  async userSignIn({ commit, dispatch }, payload) {
    commit('setLoading', true)
    try {
      //const result = await WebCalculations.tryLogin(payload)
      const result = await auth.login(payload.login, payload.password, payload.remember)
      commit('setLoading', false)
      if (result.success) {
        commit('setError', null)
        if (result.needTwoFactorAuth) {
          commit('setWaitingSecondFactorAuth', true)
        }
        else {
          commit('setLoginDialog', false)
          dispatch('checkSignIn')
        }
      }
      else if (result.FailReason) {
        commit('setError', result.FailReason)
      }
      else {
        commit('setError', i18n.t('errors.loginFailed'))
      }
    }
    catch (error) {
      commit('setError', error.message)
      commit('setLoading', false)
    }
  },
  async secondFactorLogin({ commit, dispatch }, payload) {
    commit('setLoading', true)
    commit('setLoginDialog', true)
    commit('setWaitingSecondFactorAuth', true)
    try {
      //const result = await WebCalculations.secondFactorLogin(payload)
      const result = await secondFactorLogin(payload)
      commit('setLoading', false)
      if (result.SUCCESS) {
        commit('setError', null)
        commit('setLoginDialog', false)
        dispatch('checkSignIn')
      }
      else if (result.FailReason) {
        commit('setError', result.FailReason)
      }
      else {
        commit('setError', i18n.t('errors.twoFactorLoginFailed'))
      }
    }
    catch (error) {
      commit('setError', error.message)
      commit('setLoading', false)
    }
  },
  openLoginDialog({ commit }) {
    commit('setLoginDialog', true)
  },
  async checkSignIn({ commit, dispatch }) {
    // if (!getters.isOnline) {
    //   dispatch('updateUserData')
    //   return
    // }

    commit('setLoading', true)
    commit('setIsOnline', true)
    try {
      const token = await auth.getToken()
      const isAuthenticated = !!token
      commit('setSignInChecked', true)
      if (isAuthenticated) {
        let userInfo = await getOrSetCachedValue(serviceName, 15 * 60, async () => {
          return await getUserInfo()
        })
        if (userInfo) {
          userInfo.Photo = null
          if (userInfo.NeedReLogin) {
            await dispatch('userSignOut')
          }
          if (userInfo.TimeWithoutReAuthentication) {
            setInterval(() => {
              dispatch('checkSignIn')
            }, userInfo.TimeWithoutReAuthentication * 60 * 1000)
          }
          commit('setUser', {
            ...userInfo,
            userName: userInfo.Name,
            userId: userInfo.UserId,
            login: userInfo.Login,
            photo: userInfo.Photo ? `${settings.wsPath}GetFile.ashx?file=${userInfo.Photo}&folder=content` : null,
            needCheckWorkRequests: userInfo.NeedCheckWorkRequests,
            needCheckInspections: userInfo.NeedCheckInspections,
          })
          //https://webclient.it-enterprise.com/ws/GetFile.ashx?file=9e89a3ec5e2b35008a4d969f0495f50c&folder=content&nodownload=1&quot
        }

        // if (getters.user) {
        //   if (getters.user.needCheckWorkRequests) {
        //     dispatch('checkLatestWorkRequests')
        //   }
        //   if (getters.user.needCheckInspections) {
        //     dispatch('checkCurrentInspections')
        //   }
        //   if (getters.user.EmployeeNumber) {
        //     dispatch('getTrackingTime')
        //   }
        // }
      } else {
        commit('setUser', null)
        commit('setLoginDialog', true)
      }
      commit('setLoading', false)
    } catch (error) {
      commit('setLoading', false)
    }
  },
  async userSignOut({ commit, dispatch }) {
    commit('setLoading', true)
    await unregisterDevice()
    await clearCachedValues()
    try {
      await auth.logout()
      commit('setUser', null)
      if (this.$router.currentRoute.name !== 'signin') {
        this.$router.push({ name: 'signin' })
      } else {
        window.location.reload()
      }
    } catch (e) {
      console.error('[LOGOUT]', e.message)
    } finally {
      commit('setLoading', false)
    }
    dispatch('openLoginDialog')
  },
}

const mutations = {
  setUser(state, payload) {
    state.user = payload
    let dateStart = new Date()
    if(state.user) {
      state.user.SelectionWorkRequestDays = state.user && state.user.SelectionWorkRequestDays ? state.user.SelectionWorkRequestDays : 30
      dateStart.setDate(dateStart.getDate() - state.user.SelectionWorkRequestDays)
      dateStart = dateStart.toISOString().substr(0, 10).toLocaleString()
      state.user.dateStart = dateStart
    }
    localStore.setUser(payload)
  },
  setLoginDialog(state, payload) {
    state.loginDialog = payload
  },
  setSignInChecked(state, payload) {
    state.signInChecked = payload
  },
  setWaitingSecondFactorAuth(state, payload) {
    state.waitingSecondFactorAuth = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}